import React, { useState, useEffect } from 'react';
import './Header.css';
import { HeaderLogo } from '../../assets';
import DemoButton from '../Common/DemoButton';
import { Link } from 'react-router-dom';
import { Dropdown, Space } from 'antd';

const MODULE_LINKS = [
  { to: '/products/forwarding', label: 'Forwarding',  desc: 'Air & ocean, multimodal ops' },
  { to: '/products/customs',    label: 'Customs',     desc: 'Clearance, compliance & analytics' },
  { to: '/products/finance',    label: 'Finance',     desc: 'GL, GST/VAT, approvals, credit control' },
  { to: '/products/analytics',  label: 'Analytics',   desc: 'Branch, team & vertical reports' },
  { to: '/products/sales',      label: 'Sales',       desc: 'CRM, quotes & pipeline' },
  { to: '/products/transport',  label: 'Transport',   desc: 'Road freight & e-way bills' },
  { to: '/products/warehouse',  label: 'Warehouse',   desc: 'WMS, inventory & stock' },
  { to: '/products/admin',      label: 'Admin',       desc: 'Users, roles & configuration' },
];

function MegaMenu({ onClose }) {
  return (
    <div className="mega-dropdown" onMouseDown={e => e.stopPropagation()}>
      <div className="mega-col mega-col--modules">
        <p className="mega-col-heading">Modules</p>
        <div className="mega-modules-grid">
          {MODULE_LINKS.map(({ to, label, desc }) => (
            <Link key={to} to={to} className="mega-module-item" onClick={onClose}>
              <span className="mega-module-name">{label}</span>
              <span className="mega-module-desc">{desc}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Header() {
  const [isVisible, setIsVisible]   = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [menuOpen, setMenuOpen]     = useState(false);
  const [dropOpen, setDropOpen]     = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsVisible(false);
        setDropOpen(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);
  const closeDrop = () => setDropOpen(false);

  return (
    <>
      <header className={`header ${isVisible ? 'visible' : 'hidden'}`}>
        <div className="header-container">
          <Link to={'/'} className="logo-container" onClick={closeDrop}>
            <img className="logo" src={HeaderLogo} alt="Shipmnts logo" />
          </Link>

          {/* Desktop nav */}
          <div className="actions">
            <Dropdown
              open={dropOpen}
              onOpenChange={setDropOpen}
              trigger={['hover']}
              dropdownRender={() => <MegaMenu onClose={closeDrop} />}
              placement="bottomLeft"
            >
              <span className="nav-link refer-link button-small nav-dropdown">
                <Space>Products</Space>
              </span>
            </Dropdown>

            <Link to="/why-shipmnts" className="nav-link refer-link button-small" onClick={closeDrop}>
              Why Shipmnts
            </Link>

            <button className="btn sign-in-button btn-rounded button-small">
              <a href="https://booking.shipmnts.com/">Sign In</a>
            </button>
            <span id="nav-demo-button">
              <DemoButton />
            </span>
          </div>

          {/* Mobile right side */}
          <div className="mobile-actions">
            <span id="nav-demo-button-mobile">
              <DemoButton />
            </span>
            <button
              className={`hamburger${menuOpen ? ' hamburger--open' : ''}`}
              onClick={() => setMenuOpen(o => !o)}
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
            >
              <span className="hamburger-line" />
              <span className="hamburger-line" />
              <span className="hamburger-line" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className="mobile-menu" role="dialog" aria-modal="true" aria-label="Navigation">
          <div className="mobile-menu-header">
            <Link to="/" className="logo-container" onClick={closeMenu}>
              <img className="logo mobile-menu-logo" src={HeaderLogo} alt="Shipmnts logo" />
            </Link>
            <button className="mobile-menu-close" onClick={closeMenu} aria-label="Close menu">✕</button>
          </div>

          <nav className="mobile-menu-nav">
            <div className="mobile-menu-section">
              <p className="mobile-menu-section-title">Modules</p>
              <div className="mobile-menu-product-grid">
                {MODULE_LINKS.map(({ to, label }) => (
                  <Link key={to} to={to} className="mobile-menu-product-link" onClick={closeMenu}>{label}</Link>
                ))}
              </div>
            </div>

            <div className="mobile-menu-divider" />

            <div className="mobile-menu-section">
              <Link to="/why-shipmnts" className="mobile-menu-link mobile-menu-link--featured" onClick={closeMenu}>
                Why Shipmnts
              </Link>
            </div>
          </nav>

          <div className="mobile-menu-footer">
            <a href="https://booking.shipmnts.com/" className="mobile-menu-signin" onClick={closeMenu}>
              Sign In
            </a>
            <DemoButton label="Book a Demo" onClick={closeMenu} />
          </div>
        </div>
      )}
    </>
  );
}
